import HomePage from "pages/home/HomePage";
import ProfileSettings from "pages/profile-settings/ProfileSettings";
import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { PERMISSIONS, SiteErrorType } from "utils/data/enum";
import PrivateLayout from "./PrivateLayout";
import { SiteErrorMessage } from "./components/SiteErrorMessage";
import InventoryLookupHome from "pages/lookup/InventoryLookupHome";
import InventoryAssignHome from "pages/assign/InventoryAssignHome";
import InventoryModifyHome from "pages/modify/InventoryModifyHome";
import PolicyDetails from "pages/lookup/policy-details/PolicyDetails";
import PolicyInventoryHome from "pages/policy-inventory/PolicyInventoryHome";
import PolicyManagementHome from "pages/policy-management/PolicyManagementHome";
import PolicyManagementProductDetails from "pages/policy-management/product-details/ProductDetails";
import ExceptionsHome from "pages/exceptions/ExceptionsHome";
import PremiumReceivablesHome from "pages/premium-receivables/PremiumReceivablesHome";
import ReportsHome from "pages/reports/ReportsHome";

const createElement = (element: JSX.Element, permissions?: PERMISSIONS[]) => (
  <PrivateLayout permissions={permissions}>{element}</PrivateLayout>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: createElement(<HomePage />),
  },
  {
    path: "/Home",
    element: createElement(<HomePage />),
  },
  {
    path: "/inventoryLookup",
    element: createElement(<InventoryLookupHome />, [
      PERMISSIONS.INV_LOOKUP_ACCESS,
    ]),
  },
  {
    path: "/inventoryAssign",
    element: createElement(
      <InventoryAssignHome
        saveFileRef={undefined}
        saveFileChangeRef={undefined}
        tabSaveChangesRef={undefined}
      />,
      [PERMISSIONS.INV_ASSIGN_VIEW, PERMISSIONS.INV_ASSIGN_MODIFY]
    ),
  },
  {
    path: "/inventoryModify",
    element: createElement(
      <InventoryModifyHome
        saveFileRef={undefined}
        saveFileChangeRef={undefined}
        tabSaveChangesRef={undefined}
      />,
      [PERMISSIONS.INV_MODIFY_VIEW]
    ),
  },
    {
    path: "/policyInventory",
    element: createElement(
      <PolicyInventoryHome
        saveFileRef={undefined}
        saveFileChangeRef={undefined}
        tabSaveChangesRef={undefined}
      />,
      
    ),
  },
  {
    path: "/policyManagement",
    element: createElement(
      <PolicyManagementHome
        saveFileRef={undefined}
        saveFileChangeRef={undefined}
        tabSaveChangesRef={undefined}
      />,
      [PERMISSIONS.PIP_PM_ACCESS]
    ),
  },
  {
    path: "/policyManagement/product-details/:id",
    element: createElement(<PolicyManagementProductDetails />, [
      PERMISSIONS.PIP_PM_ACCESS,
    ]),
  },
  {
    path: "/exceptions",
    element: createElement(
      <ExceptionsHome
        saveFileRef={undefined}
        saveFileChangeRef={undefined}
        tabSaveChangesRef={undefined}
      />,
      [PERMISSIONS.PIP_EXCEPTIONS_ACCESS]
    ),
  },
  {
    path: "/premiumReceivables",
    element: createElement(
      <PremiumReceivablesHome
        saveFileRef={undefined}
        saveFileChangeRef={undefined}
        tabSaveChangesRef={undefined}
      />,
      [PERMISSIONS.PIP_PREMREC_ACCESS]
    ),
  },
  {
    path: "/reports",
    element: createElement(
      <ReportsHome
        saveFileRef={undefined}
        saveFileChangeRef={undefined}
        tabSaveChangesRef={undefined}
      />,
      [PERMISSIONS.PIP_REPORTS_ACCESS]
    ),
  },
  {
    path: "/profile-settings",
    element: createElement(
      <ProfileSettings saveFileRef={undefined} saveFileChangeRef={undefined} />
    ),
  },
  {
    path: "/bad-account-message",
    element: createElement(
      <SiteErrorMessage errorType={SiteErrorType.BadAccount} />
    ),
  },
  {
    path: "/policy-details",
    element: createElement(<PolicyDetails />, [PERMISSIONS.INV_LOOKUP_VIEW]),
  },
  {
    path: "/nomoduleaccess",
    element: createElement(
      <SiteErrorMessage errorType={SiteErrorType.NoModuleAccess} />
    ),
  },
  {
    path: "403",
    element: createElement(
      <SiteErrorMessage errorType={SiteErrorType.NoAccess} />
    ),
  },
  {
    path: "404",
    element: createElement(
      <SiteErrorMessage errorType={SiteErrorType.NotFound} />
    ),
  },
  {
    path: "*",
    element: createElement(
      <SiteErrorMessage errorType={SiteErrorType.NotFound} />
    ),
  },
  {
    path: "/permissionDenied",
    element: createElement(<SiteErrorMessage errorType={SiteErrorType.PermissionDenied} />),
  },
]);

export default router;
